module.exports = " <div class=league-countries> <template v-for=\"(key, country) in leagueCountries\"> <span v-if=\"lang == 'en'\" class=\"tag is-medium is-primary\">{{country.en.name}}</span> <input v-model=country[lang].name v-else :value=country[lang].name :placeholder=country.en.name class=input /> </template> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeagueCountries.vue
 ** module id = 50
 ** module chunks = 1
 **/